function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.07653 13.9022L8.68684 13.5004C8.59681 13.4072 8.54714 13.2843 8.54714 13.1539C8.54714 13.0228 8.59681 12.8999 8.68684 12.8073L12.6467 8.72301L1.29598 8.72301C1.12459 8.72301 0.984864 8.58388 0.984864 8.41312L0.984864 7.60643C0.984864 7.43505 1.12459 7.29594 1.29598 7.29594L12.6498 7.29594L8.68684 3.2091C8.59681 3.11657 8.54714 2.99299 8.54714 2.86258C8.54714 2.73155 8.59681 2.60858 8.68684 2.51606L9.07653 2.11427C9.16845 2.01926 9.29109 1.96709 9.42182 1.96709C9.55285 1.96709 9.67582 2.01926 9.76803 2.11427L14.8364 7.34127C14.8423 7.34749 14.8475 7.35368 14.8522 7.35929C14.9283 7.41704 14.9748 7.50708 14.9748 7.60645L14.9748 8.41312C14.9748 8.51433 14.9264 8.60625 14.8469 8.66338C14.8432 8.66772 14.8395 8.67208 14.8351 8.67645L9.76772 13.9022C9.67582 13.9972 9.55286 14.0494 9.42181 14.0494C9.29109 14.0494 9.16845 13.9966 9.07653 13.9022Z",
  fill: "currentcolor"
});

const SvgArrowRight = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-right.e01b4b64.svg";
export { ForwardRef as ReactComponent };